import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/contact-us-screen';

function ContactUs() {
  return <Screen />;
}
export default ContactUs;
